/**
 * Created by ddodson on 12/15/15.
 */
import React, { Component, PropTypes } from 'react';
import ReactDOM from 'react-dom';
import styles from './StackedBarChart.css';
import { xlt } from '../../utils/utils';
import withStyles from '../../decorators/withStyles';

const d3 = require('d3');
d3.tip = require('d3-tip').default;


class StackedBarChart extends Component {

  static propTypes = {
    data: PropTypes.array.isRequired,
    // isWaterLevel: PropTypes.bool.isRequired
  };

  componentDidMount() {
    this.create(
      ReactDOM.findDOMNode(this),
      typeof this.props.data !== 'undefined' ? this.props.data : []
    );
  }

  shouldComponentUpdate(props) {
    return this.props.data !== props.data;
  }

  componentDidUpdate() {
    this.update(
      ReactDOM.findDOMNode(this),
      typeof this.props.data !== 'undefined' ? this.props.data : []
    );
  };

  componentWillUnmount() {
    var el = ReactDOM.findDOMNode(this);
    this.destroy(el);
  }

  create(element, data) {
    
    const { width, height, margin } = this.props;
    var svgWidth = width + margin.left + margin.right;
    var svgHeight = height + margin.top + margin.bottom;

    const yVal = (d) => d[1] - d[0];

    this.tip = d3.tip().attr("class", "d3-tip")
      .direction("n")
      .offset([-5, 0])
      .html((d) => `${yVal(d)} ${xlt('days')}`);

    var svg = d3.select(element).append("svg")
      .attr("viewBox", "0 0 " + svgWidth + " " + svgHeight)
      .append("g")
      .classed("graph-canvas", true)
      .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    svg.call(this.tip);

    this.update(element, data);
  };

  update(element, data) {
    const { width, height, margin, xLabel, yLabel } = this.props;
    var x = d3.scaleBand()
      .rangeRound([0, width]).padding(0.1);

    var y = d3.scaleLinear()
      .range([height, 0]);

    const keys = ["natural_days", "anthro_days"];

    x.domain(data.map(d => d.date));
    y.domain([0, d3.max(data, d => (d.natural_days + d.anthro_days))]);

    var yTickFormat = ',.0f';

    d3.selectAll(".StackedBarChart .bar, .StackedBarChart .axis").remove();

    var svg = d3.select(element).selectAll(".graph-canvas");

    var xAxis = d3.axisBottom(x);

    var yAxis = d3.axisLeft(y)
      .ticks(5, yTickFormat);

    svg.append("g")
      .classed("x axis", true)
      .attr("transform", "translate(0," + height + ")")
      .call(xAxis)
      .append("text")
      .attr("y", margin.bottom / 2)
      .attr("x", width / 2)
      .attr("dy", "1.5em")
      .style("text-anchor", "middle")
      .text(xlt(xLabel));

    svg.append("g")
      .classed("y axis", true)
      .call(yAxis)
      .append("text")
      .attr("transform", "rotate(-90)")
      .attr("y", - margin.left)
      .attr("x", - (height / 2))
      .attr("dy", "1em")
      .style("text-anchor", "middle")
      .text(xlt(yLabel));

    var legend = svg.append("g")
      .attr("transform", "translate(0," + -margin.top + ")")
      .classed("legend", true);

    legend.append("rect")
      .attr("fill", "#61edff")
      .attr("width", 10)
      .attr("height", 10)
      .attr("y", 3)
      .attr("x", 15);

    legend.append("text")
      .text(xlt("Would have occurred anyway"))
      .classed("legend", true)
      .attr("font-size", "2vw")
      .attr("y", 13)
      .attr("x", 30);

    legend.append("rect")
      .attr("fill", "#FA7533")
      .attr("width", 10)
      .attr("height", 10)
      .attr("y", -14)
      .attr("x", 15);

    legend.append("text")
      .text(xlt("Driven by climate-linked sea level rise"))
      .classed("legend", true)
      .attr("font-size", "2vw")
      .attr("y", -4)
      .attr("x", 30);

    const stack = d3.stack()
      .keys(keys)
      .order(d3.stackOrderNone)
      .offset(d3.stackOffsetNone);

    const dataSeries = stack(data);

    const getYVal = (d) => d[1] - d[0];
    const getLabel = (key) => key.replace('_days', '');

    const dataDescr = (stackData) => {
      const days = getYVal(stackData);
      const key = Object.keys(stackData.data).find((key) => stackData.data[key] === days);
      const category = getLabel(key);
      const date = stackData.data.date;
      return category + '_' + days + '_' + date;
    };

    const series = svg.append("g")
      .classed("StackedBarSeries", true)
      .selectAll("g")
      .data(dataSeries)
      .enter().append("g")
        .attr("class", (d) => getLabel(d.key))
        .selectAll("rect")
        .data((d) => d)
        .enter().append("rect")
          .attr("x", (d) => x(d.data.date))
          .attr("y", (d) => y(d[1]))
          .classed("bar", true)
          .attr("height", (d) => y(d[0]) - y(d[1]))
          .attr("width", x.bandwidth())
          .attr("data-bar", (d) => dataDescr(d))
          .on("mouseover", this.tip.show)
          .on("mouseout", this.tip.hide);

  };

  destroy(element) {
    // TODO
  };

  render() {
    return <div className="StackedBarChart">{this.props.children}</div>;
  }

}

export default withStyles(styles)(StackedBarChart);
